import Vue, { PropType } from 'vue';
import OS from "js/framework/utils/OS";

import commonStyle from "./css/common.module.css";
import style from "./css/TopMenu.module.css";

export default Vue.extend({
  data() {
    return {
      hover: false,
    }
  },
  watch: {
    hover(val) {
      if (this.hoverHandler) this.hoverHandler(val);
    },
  },
  props: {
    label: String,
    imgSrc: String,
    clickHandler: Function as PropType<() => void>,
    hoverHandler: Function as PropType<(over: boolean) => void>,
  },
  render() {
    const { clickHandler = () => {} } = this;

    return (
      <button
        class={[style.menuButton, OS.desktop ? style.menuButtonSubmenu : style.menuButtonSubmenuMobile]}
        onClick={clickHandler}
        onmouseover={() => this.hover = true}
        onmouseleave={() => this.hover = false}
      >
        <div class={commonStyle.buttonLabel}>
          <img class={commonStyle.labelIcon} src={this.imgSrc} />
          {OS.desktop ? <div class={style.labelText}>{ this.label }</div> : null}
          {OS.desktop ? <img class={style.labelArrow} src="images/Arrow_Down.svg" /> : null}
        </div>
        { this.$slots.default ? this.$slots.default : null }
      </button>
    );
  },
});
